import i from "react";

import l from "./SlackChannelOption.mjs";

const s = ({
  slackChannels: m,
  isLoading: o,
  connectedChannels: t,
  onClick: a,
  listBoxProps: e,
  channelOptionProps: p,
  isUpdating: d
}) => /* @__PURE__ */ i.createElement("div", { className: "rsk-combobox__list-box", ...e }, m.map((r) => /* @__PURE__ */ i.createElement(l, { key: r.id, tabIndex: 0, channel: r, isLoading: o, isConnected: !!(t != null && t.find((f) => f.channel_id === r.id)), onClick: a, channelOptionProps: p, isUpdating: d })));
export {
  s as default
};
//# sourceMappingURL=SlackChannelListBox.mjs.map
